<script>
import {
  Chart as ChartJS,
  BarElement,
} from 'chart.js';

import { Bar } from 'vue-chartjs/legacy';

ChartJS.register(BarElement);

export default {
  name: 'ChartBar2',
  components: { BarChart2: Bar },
  props: {
    data: Array,
    barConfig: Object,
    chartId: String,
  },
  computed: {
    dataSets() {
      return {
        labels: this.barConfig.labels,
        datasets: [{
          data: this.data,
          backgroundColor: this.barConfig.backgroundColors,
          barThickness: this.barConfig.barThickness,
          borderWidth: this.barConfig.borderWidth,
          borderRadius: this.barConfig.borderRadius,
        }],
      };
    },

    config() {
      return {
        type: 'bar',
        data: this.dataSets,
        options: {
          plugins: {},
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: this.barConfig.stepSize,
                display: false,
              },
            },
          },
        },
      };
    },
  },
};
</script>

<template lang="pug">
BarChart2.chart-canvas(:chart-options="config.options" :chart-data="config.data")
</template>

<style scoped lang="scss">
.chart-canvas {
  width: 100%;
  height: 100%;
  &::v-deep .canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
